import { createReducer, on } from '@ngrx/store';
import { PaginationResponse } from '@shared/models/common.model';

import * as VaultActions from './vault.actions';
import { VaultListItem } from '../../models/vault.model';
import { WalletListItem } from '../../models/wallet.model';

export interface SharedVaultState {
  vaults: VaultListItem[];
  loading: boolean;
  error: string | null;

  wallets: WalletListItem[];
  walletsLoading: boolean;
  walletsError: string | null;
  walletsPagination: PaginationResponse | null;
  pagination: PaginationResponse | null;
  hasMore: boolean;
}

export const initialState: SharedVaultState = {
  vaults: [],
  loading: false,
  error: null,
  wallets: [],
  walletsLoading: false,
  walletsError: null,
  walletsPagination: null,
  pagination: null,
  hasMore: false,
};

export const sharedVaultReducer = createReducer(
  initialState,

  // Load
  on(VaultActions.loadVaults, state => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(VaultActions.loadVaultsSuccess, (state, { data, pagination, append }) => ({
    ...state,
    vaults: append ? [...state.vaults, ...(data ?? [])] : (data ?? []),
    loading: false,
    error: null,
    pagination: pagination ?? null,
    hasMore: !!pagination && pagination.page < pagination.totalPages,
  })),

  on(VaultActions.loadVaultsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Wallets
  on(VaultActions.loadWallets, (state, { append = false }) => ({
    ...state,
    walletsLoading: true,
    walletsError: null,
    // When loading the first page (append = false), clear previous wallets to avoid showing stale data
    wallets: append ? state.wallets : [],
    walletsPagination: append ? state.walletsPagination : null,
  })),

  on(
    VaultActions.loadWalletsSuccess,
    (state, { wallets, pagination, append }) => ({
      ...state,
      wallets: append ? [...state.wallets, ...wallets] : wallets,
      walletsPagination: pagination,
      walletsLoading: false,
      walletsError: null,
    })
  ),

  on(VaultActions.loadWalletsFailure, (state, { error }) => ({
    ...state,
    walletsLoading: false,
    walletsError: error,
  }))
);
